module.exports = __webpack_public_path__ + "img/akagi_vue.15724147.jpg";